module.exports = __webpack_public_path__ + "static/media/05.8431d384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/05.jpg
// module id = 266
// module chunks = 0